import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiService } from './_services/api.service';
import { SnsNotificationsComponent } from './components/sns-notifications/sns-notifications.component';
import { SnsNotificationItemComponent } from './components/sns-notification-item/sns-notification-item.component';


@NgModule({
   declarations: [
      AppComponent,
      SnsNotificationsComponent,
      SnsNotificationItemComponent,
   ],
   imports: [
      BrowserModule,
      AppRoutingModule,
      HttpClientModule,
      FormsModule,
      AgGridModule.withComponents([]),
   ],
   providers: [ApiService],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }
